var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center",staticStyle:{"height":"90vh"}},[_vm._v("\n    "+_vm._s(_vm.$langt('SSO 登入'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }